import { groupBy } from 'lodash';
import moment from 'moment';
import {
  SHOW,
  HIDE,
  LOAD_EPG,
  LOAD_EPG_ERROR,
  LOAD_EPG_SUCCESS,
  LOAD_EXTRA_EPG,
  LOAD_EXTRA_EPG_SUCCESS,
} from './action-types';
import { AsyncAction } from 'store/types';
import requester from 'utils/requester';
import { IRequesterResponse, LiveEventType } from 'store/pages/loaders/loader-types';
import api from 'config/api';
import { epgSelectors } from '.';

const FIVE_MINUTES_IN_MS = 1000 * 60 * 5;

export const show = () => ({ type: SHOW });
export const hide = () => ({ type: HIDE });

export type LoadEPGPayloadType = {
  channelIds: number[];
};

export const loadEpg: AsyncAction<LoadEPGPayloadType> = (payload) => async (dispatch, getState) => {
  try {
    const state = getState();
    const prevUpdatedAt = epgSelectors.selectUpdatedAt(state);

    if (Date.now() - prevUpdatedAt <= FIVE_MINUTES_IN_MS) {
      // no need to update
      return null;
    }
    const { channelIds } = payload;
    dispatch({ type: LOAD_EPG, payload });

    const now = Date.now();
    const startTime = moment(now).subtract(4, 'hour').toISOString();
    const endTime = moment(now).add(4, 'hour').toISOString();

    const { data } = (await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.liveEvents}`,
      params: {
        'live.id[in]': channelIds.join(','),
        $expand: 'thumbnail(url),program,dvr,live',
        'start_time[gt]': startTime,
        'end_time[lt]': endTime,
      },
    })) as IRequesterResponse<LiveEventType[]>;

    const groupped = groupBy(data, 'live_id');
    const updatedAt = Date.now();

    dispatch({ type: LOAD_EPG_SUCCESS, payload: { data: groupped, updatedAt } });
  } catch (error) {
    console.error(error);
    dispatch({ type: LOAD_EPG_ERROR, payload: error.message });
  }
};

export const loadExtraEpg = (payload) => async (dispatch) => {
  try {
    // const state = getState();
    // const epg = epgSelectors.selectEPG(state);
    const { channelId } = payload;

    const now = Date.now();
    // range of 5 days
    const startTime = moment(now).startOf('day').subtract(1, 'days').toISOString();
    const endTime = moment(now).endOf('day').add(1, 'days').toISOString();

    dispatch({ type: LOAD_EXTRA_EPG, payload });

    const { data } = (await requester({
      method: 'get',
      url: `${api.host}${api.endpoints.liveEvents}`,
      params: {
        'live.id[eq]': channelId,
        $expand: 'thumbnail(url),program,dvr,live',
        'start_time[gt]': startTime,
        'end_time[lt]': endTime,
      },
    })) as IRequesterResponse<LiveEventType[]>;

    dispatch({ type: LOAD_EXTRA_EPG_SUCCESS, payload: { channelId, data } });
  } catch (error) {
    dispatch({ type: LOAD_EPG_ERROR, payload: error.message });
    console.error(error);
  }
};
